import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, type State, TemplatesStore } from './TemplatesStore';

export const useTemplatesActions = createActionsHook<State, Actions>(TemplatesStore);
